var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDuration01 = function SvgIconDuration01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_duration-01_svg2__a",
    x1: -2.42,
    x2: 103.69,
    y1: 73.29,
    y2: 26.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_duration-01_svg2__a",
    id: "icon_duration-01_svg2__b",
    x1: -2.6,
    x2: 103.5,
    y1: 72.86,
    y2: 25.7
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.51 46.51c-1.93 0-3.49 1.56-3.49 3.49 0 15.38-8.21 29.59-21.53 37.27C50.9 99.15 24.58 92.08 12.71 71.5.82 50.91 7.89 24.59 28.48 12.71 47.21 1.9 70.69 6.78 83.72 23.26H73.26c-1.93 0-3.49 1.56-3.49 3.49s1.56 3.49 3.49 3.49h17.17c.1 0 .2-.01.29-.02h.02a3.48 3.48 0 0 0 3.04-3.23l1.2-18.6v-.02a3.49 3.49 0 0 0-3.26-3.7A3.54 3.54 0 0 0 88 7.93l-.58 8.91C78.03 6.25 64.47 0 50.02 0 22.4 0 .01 22.38 0 49.99c0 27.61 22.38 50 49.99 50.01 27.6-.03 49.97-22.4 50-50 0-1.93-1.56-3.49-3.49-3.49Z",
    style: {
      fill: "url(#icon_duration-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 23.26c-1.93 0-3.49 1.56-3.49 3.49v23.26c0 1.1.52 2.13 1.4 2.79l18.6 13.95c.6.45 1.34.7 2.09.7 1.1 0 2.14-.52 2.8-1.4 1.16-1.54.84-3.73-.7-4.88L53.49 48.26V26.75c0-1.93-1.56-3.49-3.49-3.49",
    style: {
      fill: "url(#icon_duration-01_svg2__b)"
    }
  }));
};
export default SvgIconDuration01;